<template>
  <a-row class="headbar" type="flex" align="middle" justify="space-between">
    <template v-if="status === 1">
      <a-col>
        <h3 style="margin-left:20px ">群成员</h3>
      </a-col>
      <a-col>
        <a-button
          size="small"
          icon="plus"
          type="primary"
          ghost
          style="margin-right:10px "
          @click="operate(2)"
          >添加</a-button
        >
        <a-button
          size="small"
          icon="minus"
          type="danger"
          ghost
          @click="operate(3)"
          >剔除</a-button
        >
      </a-col>
    </template>
    <template v-else-if="status === 2">
      <a-col>
        <a-button size="small" type="link" icon="left" @click="cancel(2)"
          >选择邀请的人</a-button
        >
      </a-col>
      <a-col>
        <a-button type="primary" size="small" @click="$emit('add')"
          >确定</a-button
        >
      </a-col>
    </template>
    <template v-else>
      <a-col>
        <a-button size="small" type="link" icon="left" @click="cancel(3)"
          >选择剔除的人</a-button
        >
      </a-col>
      <a-col>
        <a-button type="primary" size="small" @click="$emit('remove')"
          >确定</a-button
        >
      </a-col>
    </template>
  </a-row>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      status: 1 //1.初始化   2.添加  3.删除
    };
  },
  methods: {
    operate(status) {
      this.status = status;
      this.$emit("operate", status);
    },
    cancel(status) {
      this.init();
      this.$emit("cancel", status);
    },
    init() {
      this.status = 1;
    }
  }
};
</script>

<style scoped lang="scss">
.headbar {
  height: 49px;
  line-height: 48px;
  border-bottom: 1px solid #e7e7e7;
  padding: 0 20px 0 0;
}
</style>
